class InitRouter {
    //We are using incorrectly angular-route library, $state.go is a function from angular-ui-router
    $state: ng.route.IRoute & { go: any };
    preconditionEvent: any;
    private paramPaRes: string;
    private paramMD: string;

    constructor (
        private $rootScope: CommonsRootScope,
        private CommonsIberiaRouterPreconditionsService: CommonsIberiaRouterPreconditionsService,
        private $window: ng.IWindowService,
        private SubscriptionModelsUtilService: any,
        private CommonsSessionStorageService: CommonsSessionStorageService
    ) {

    }

    active=():void=> {
        this.preconditionEvent = this.$rootScope.$on('$routeChangeStart', (event, toState, toParams) => {

            this.paramPaRes = this.SubscriptionModelsUtilService.getParameterByName('PaRes');
            this.paramMD = this.SubscriptionModelsUtilService.getParameterByName('MD');
            if (this.paramMD && this.paramPaRes) {
                event.preventDefault();
                this.CommonsSessionStorageService.set('componentInfoAdyen', {md: this.paramMD, paRes: this.paramPaRes});
                this.$window.location = this.$window.location.pathname + this.$window.location.search.split(/[?&]MD(=([^&#]*)|&|#|$)[?&]PaRes(=([^&#]*)|&|#|$)/)[0];
            }
            if (!this.CommonsIberiaRouterPreconditionsService.canTransition(toState.name, toParams)) {
                //Stop the state transition from working
                event.preventDefault();
                //Navigate to a otherwise state OR reload the app
                if (this.CommonsIberiaRouterPreconditionsService.otherwise(toState.name) ) {
                    this.$state.go(this.CommonsIberiaRouterPreconditionsService.otherwise(toState.name));
                } else {
                    this.$window.location.href = this.$window.location.href.split('#')[0]; // Application is in a unrecoverable state reload
                }
            }
        });
    };

    $onInit = this.active();
}
InitRouter.$inject = ['$rootScope', 'CommonsIberiaRouterPreconditionsService', '$window', 'SubscriptionModelsUtilService', 'CommonsSessionStorageService'];


angular.module('ib-subscription-models-routing-module', [
    'ngRoute'
]);
angular.module('ib-subscription-models-routing-module').run(InitRouter);
